export const environment = {
  production: true,
  navBarBackgroundColor: 'purple',
  apiUrl: "https://api.kawtharuna.com/v1",

}
